import { Component } from '@angular/core';
import { MenuStateService } from '../../../services/menu-state.service';

@Component({
  selector: 'app-mobile-novedades',
  standalone: false,
  templateUrl: './mobile-novedades.component.html',
  styleUrl: './mobile-novedades.component.css'
})
export class MobileNovedadesComponent {
  constructor(private menuStateService: MenuStateService){  }
  
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}

